import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useField } from 'react-final-form';

import { useGetLanguagesQuery } from 'modules/translations/service';

import SelectInput from 'components/ui/SelectInput';
import Flag from 'components/ui/LanguageSelect/components/Flags';

const LanguageInput: React.FC = () => {
  const intl = useIntl();
  const { data = [] } = useGetLanguagesQuery();
  const { input } = useField('language', { subscription: { value: true } });

  const languages = data.reduce((acc: Record<string, React.ReactNode>, element: string) => ({
    ...acc,
    [element]: <FormattedMessage id={`language.${element}`} defaultMessage={element.toUpperCase()} />,
  }), {});

  const renderOption = React.useCallback((language: string, label: React.ReactNode) => (
    <span className="flex items-center gap-2">
      <Flag locale={language} className="size-6" />
      {label}
    </span>
  ), []);

  return (
    <SelectInput
      {...input}
      label={intl.formatMessage({ id: 'customerInfo.language', defaultMessage: 'Language' })}
      data={languages}
      renderOption={renderOption}
      data-testid="language-input"
    />
  );
};

export default LanguageInput;
